<template>
<div>
	<b-breadcrumb class="flex-nowrap m-0 rounded-0" :items="breadcrumbs"/>
	
	<loading-panel loading-text="Загрузка списка ТУ" v-if="isLoading && !departments" />
	<div class="p-4" v-if="departments && Array.isArray(departments) && departments.length > 0">
		<b-row>
			<b-col v-for="department in departments" cols="12" md="6" lg="6" xl="3" class="mb-3">
				<router-link class="page-menu-item border h-100 position-relative" :to="'/knd/knd_forms_01/' + department.id">
					<b-row class="">
						<b-col cols="12">
							<div class="h6 d-flex align-items-start text-truncate">
								<span v-if="department" class="badge badge-light border mr-2 font-size-11">{{ department.code }}</span> 
								<span class="text-truncate">{{ department.title }}</span>
							</div>
							<div class="font-size-14 mb-2 pb-2 border-bottom">
								<template v-if="department.min_year && department.max_year">
									{{ moment(department.min_year).format('Y') }} <span v-if="department.min_year !== department.max_year"> – {{ moment(department.max_year).format('Y') }}</span>
								</template>
								<template v-else>
									-
								</template>
							</div>
							<div class="font-size-14">
								<decl-of-num v-if="department.knd_forms_01_count" :number="department.knd_forms_01_count" :titles="['форма', 'формы', 'форм']" :print="true" />
								<span v-else class="text-muted">Формы отсутствуют</span>
							</div>
						</b-col>
					</b-row>
				</router-link>
			</b-col>
		</b-row>
	</div>
</div>
</template>

<script>
import moment from 'moment'
export default {
	props: [],
	data () {
		return {
			moment: moment,
			departments: [],
			currentDepartment: null,
			isLoading: false,
		}
	},
	mounted () {
		this.fetchDepartment()
	},
	methods: {
		selectDepartment (id) {
			this.currentDepartment = id
			this.$refs.modal.hide()
		},
		fetchDepartment () {
			if (this.isLoading) {
				return false
			}
			this.isLoading = true

			let url = process.env.VUE_APP_API_ROOT + '/api/knd/knd_forms_01'

			this
				.$http
				.get(url)
				.then(res => {
					this.departments = res.data.departments
					if (this.$route.params.departmentid) {
						this.currentDepartment = this.$route.params.departmentid
					}
				})
				.catch(err => {
					this.$notify({
					  group: 'main',
					  text: 'Ошибка получения списка территориальных управлений',
					  duration: 3000,
					  type: 'alert-danger'
					})
				})
				.then(() => {
					this.isLoading = false
				})
		},
		fetchData () {
		}
	},
	computed: {
		breadcrumbs () {
			let arr = []

			arr.push({
				to: '/',
				text: 'Главная'
			})

			arr.push({
				to: '/knd',
				text: 'Контрольно-надзорная деятельность'
			})

			arr.push({
				to: '/knd/knd_forms_01',
				text: 'Форма №1'
			})

			return arr
		}
	}
}
</script>